// extracted by mini-css-extract-plugin
export default {"gridPrice":"ZCg8J","priceAndDiscount":"eS10x"};